import { computed } from 'vue'
import { useStore } from 'vuex'

import { OTLBrowserSDK } from '@/lib/oTel'
import { SERVICE_NAME } from '@/lib/oTel/constants'

export const useOpenTelemetry = () => {
  const version = __SENTRY_RELEASE__
  const environment =
    __ENVIRONMENT__ === 'production' ? 'production' : 'development'

  const store = useStore()

  const userId = computed(() => store.getters['account/getUserId'])

  const tracer = computed(() => {
    return (
      OTLBrowserSDK.tracer ?? {
        startSpan: () => {
          console.log('Error: OpenTelemetry has not been initialized yet')
        }
      }
    )
  })

  const initOpenTelemetry = () => {
    OTLBrowserSDK.init({
      instrumentations: {
        fetch: true,
        document: true,
        interactions: true,
        xhr: true
      },
      application: SERVICE_NAME,
      version,
      environment,
      customerId: userId.value
    })
  }

  return {
    initOpenTelemetry,
    tracer
  }
}
